// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { dashboardSummaryRequested, dashboardSummaryRequestFailed, dashboardSummaryRequestSucceeded } from './dashboard-summary.actions';
import { DashboardSummary } from '../models/dashboard-summary';

export const STATE_NAME = 'dashboard-summary';

export interface DashboardSummaryState {
  isLoading: boolean;
  summary?: DashboardSummary;
  summaryError: boolean;
}

const initialState: DashboardSummaryState = {
  isLoading: false,
  summary: undefined,
  summaryError: false,
};

const reducer = createReducer(
  initialState,
  on(dashboardSummaryRequested, (state) => ({
    ...state,
    isLoading: true,
    summary: undefined,
    summaryError: false,
  })),
  on(dashboardSummaryRequestSucceeded, (state, {summary}) => ({
    ...state,
    summary,
    isLoading: false,
    summaryError: false,
  })),
  on(dashboardSummaryRequestFailed, (state) => ({
    ...state,
    isLoading: false,
    summaryError: true,
  })),
);

export function dashboardSummaryReducer(state: DashboardSummaryState | undefined, action: Action): any {
  return reducer(state, action);
}
